export default __webpack_public_path__ + "static/transportation-hero-c8cb00d26cd3a4bc3a01988eb9d20a34.webp";